import React, { useEffect, useState } from 'react';

export default function Report(param : any){

    var period = param.period.accountingPeriod;
    var mechanicalContract  = param.period.mechanicalContract
    var collectorContract = param.period.collectorContract
    var publishingContract= param.period.publishingContract
    var royaltyContract = param.period.royaltyContract

    return (

        <div className="ws-12">

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"} > 
                    <i className="icon-file-pdf-o"> Summary 101 </i> 
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"} > 
                    <i className="icon-file-pdf-o"> 102 PDF Detail By Contract</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn edit  ms" : "hide"} > 
                    <i className="icon-file-excel-o">102 Excel Detail By Contract </i>
                </button>



                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"} >
                    <i className="icon-file-pdf-o">102 PDF Detail By Contact</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn edit ms" : "hide"} >
                    <i className="icon-file-excel-o">102 Excel Detail By Contact</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}>
                    <i className="icon-file-pdf-o">Profit Statement 104</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}>
                    <i className="icon-file-pdf-o">Profit Statement 104 By Contact</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}> 
                    <i className="icon-file-pdf-o">By Contract 121 </i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}> 
                    <i className="icon-file-pdf-o">By Contact 121</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}> 
                    <i className="icon-file-pdf-o">By Contract 122 </i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}> 
                    <i className="icon-file-pdf-o">By Contact 122</i>
                </button>

                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn edit ms" : "hide"}> 
                    <i className="icon-file-excel-o">Excel By Contract 122</i>
                </button>


                <button className={(period !==3 && (!((mechanicalContract || collectorContract) || publishingContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}> 
                    <i className="icon-file-pdf-o">Contract Listing</i>
                </button>

             
                <button className={(period !==3 && (mechanicalContract || collectorContract) )? "icon-btn delete ms" : "hide"} >
                    <i className="icon-file-pdf-o">Mech Statement 401 PDF</i>
                </button>

                <button className={(period !==3 && (mechanicalContract || collectorContract) )? "icon-btn edit ms" : "hide"}>
                    <i className="icon-file-excel-o">Mech Statement 401 EXCEL</i>
                </button>

                <button className={(period !==3 && (mechanicalContract || collectorContract) )? "icon-btn delete ms" : "hide"} >
                    <i className="icon-file-pdf-o">Mech 402</i>
                </button>

                <button className={(period !==3 && publishingContract )? "icon-btn delete ms" : "hide"} >
                    <i className="icon-file-pdf-o">Summary 601</i>
                </button>

                <button className={(period !==3 && publishingContract )? "icon-btn delete ms" : "hide"}   >
                    <i className="icon-file-pdf-o">Report 602</i>
                </button>

                <button className={(period === 1)? "icon-btn delete ms" : "hide"}   >
                    <i className="icon-file-pdf-o">106 Statement</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}  > 
                    <i className="icon-file-pdf-o">Summary 111</i>
                </button>


                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}  > 
                    <i className="icon-file-pdf-o">112 PDF By Contract</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn edit ms" : "hide"}  > 
                    <i className="icon-file-excel-o">112 Excel By Contract </i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn edit ms" : "hide"}  > 
                    <i className="icon-file-excel-o">112 Excel By Contact</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}   > 
                    <i className="icon-file-pdf-o">114</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}  > 
                    <i className="icon-file-pdf-o">116</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}   > 
                    <i className="icon-file-pdf-o">By Contract 121 </i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}   > 
                    <i className="icon-file-pdf-o">By Contact 121</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || collectorContract || publishingContract || royaltyContract)))? "icon-btn delete ms" : "hide"}   > 
                    <i className="icon-file-pdf-o">By Contract 122</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || publishingContract || collectorContract) || royaltyContract ))? "icon-btn delete ms" : "hide"}  > 
                    <i className="icon-file-pdf-o">By Contact 122</i>
                </button>


                {/********** */}
                <button className={(period === 3 && (!(mechanicalContract || publishingContract || collectorContract) || royaltyContract ))? "icon-btn edit ms" : "hide"} > 
                    <i className="icon-file-excel-o">Excel By Contract 122</i>
                </button>

                <button className={(period === 3 && (!(mechanicalContract || publishingContract || collectorContract) || royaltyContract ))? "icon-btn delete ms" : "hide"} > 
                    <i className="icon-file-pdf-o">Contract Listing</i>
                </button>

                <button className={(period === 3 && (mechanicalContract || collectorContract))? "icon-btn delete ms" : "hide"} > <i className="icon-file-pdf-o">Mech 412</i></button>

                <button className={(period === 3 && (mechanicalContract || collectorContract))? "icon-btn delete ms" : "hide"}  > <i className="icon-file-pdf-o">Mech Summary 410</i></button>

                <button className={(period === 3 && (mechanicalContract || collectorContract))? "icon-btn delete ms" : "hide"} > <i className="icon-file-pdf-o">Mech Statement 411</i></button>

                <button className={(period === 3 && (publishingContract))? "icon-btn delete ms" : "hide"}> <i className="icon-file-pdf-o">Report 602</i></button>

                <button className={(period === 3 && (publishingContract))? "icon-btn delete ms" : "hide"} > <i className="icon-file-pdf-o">Report 601</i></button>

                <div className="hide">
                    <div className="row-fluid mtl" >
                        <div className="ws-12" >

                            <button className="icon-btn delete" ><i className="icon-file-pdf-o"></i> </button>

                            <button className="icon-btn delete"><i className="icon-file-pdf-o"></i></button>

                            <button className="icon-btn edit"><i className="icon-file-excel-o"></i></button>

                            <div className="verticalLine"></div>

                            <button className="icon-btn delete" ><i className="icon-file-pdf-o"></i></button>

                            <button className="icon-btn delete" ><i className="icon-file-pdf-o"></i> </button>

                            <button className="icon-btn edit" ><i className="icon-file-excel-o"></i></button>



                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete" ng-click="openReports('crystalReport', '101', kontactCode, '', periodSelected, contractTitle, contractRefNum)"><i className="icon-file-pdf-o"></i> </button>
                                <div className="hover-block">
                                    <a className="hover-box icon-btn delete btn-xs pull-left"  ng-click="openReports('crystalReport', '101', kontactCode, '', periodSelected, contractTitle, contractRefNum)">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"><i className="icon-files"></i> </button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left" >RPT</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left" >EXCEL</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left" >CSV</a>
                                </div>
                            </div>


                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"><i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">RPT</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">EXCEL</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">CSV</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"><i className="icon-file-pdf-o"></i> </button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF By Contact</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete" ><i className="icon-files"></i>  </button>
                                <div className="hover-block">

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contact</a>

                                </div>
                            </div>
                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"><i className="icon-files"></i> </button>
                                <div className="hover-block">

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contact</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">EXCEL</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"><i className="icon-file-pdf-o"></i> </button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF</a>
                                </div>
                            </div>

                        </div>

                        <div className="ws-12 mt" ng-show="contractDetails.mechanicalContract || contractDetails.collectorContract">

                            <button className="icon-btn delete"><i className="icon-file-pdf-o"></i></button>

                            <button className="icon-btn delete" ><i className="icon-file-pdf-o"></i></button>


                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"><i className="icon-file-pdf-o"></i> </button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box btn btn-large icon-btn delete pull-left hide" >
                                <i className="fa fa-file-text"></i><span></span>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete" ><i className="icon-files"></i> </button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF</a>
                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">EXCEL</a>
                                </div>
                            </div>

                        </div>

                        <div className="ws-12 mt" ng-show="contractDetails.publishingContract">

                            <button className="icon-btn delete"><i className="icon-file-pdf-o"></i></button>

                            <button className="icon-btn delete"><i className="icon-file-pdf-o"></i></button>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">EXCEL</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb hide">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                        </div>

                        <div className="hover-box btn btn-large icon-btn delete pull-left mb hide">
                            <i className="icon-save" data-ng-click="postAdjPercentage(periodSelected, contractRefNum)"></i>
                        </div>

                        <div className="hover-box icon-btn delete pull-left hide"><i className="icon-calculator"></i><span data-ng-click="reCalcPaymentPayment()"> </span></div>

                    </div>

                    <div className="row-fluid pm hide" ng-show="contractDetails.accountingPeriod === 3" ng-data="Bi-Annual">
                        <div ng-show="(!(contractDetails.mechanicalContract || contractDetails.publishingContract || contractDetails.collectorContract) || contractDetails.royaltyContract )">

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>

                                <div className="hover-block">

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF Report By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">Rpt By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">Rpt By Contact</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left" >XLSX By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">XLSX By Contact</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>
                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>

                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contact</a>
                                </div>
                            </div>


                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>

                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contract</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF By Contact</a>


                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">EXCEL</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>
                        </div>

                        <div ng-show="contractDetails.mechanicalContract || contractDetails.collectorContract" >

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>

                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF</a>
                                </div>
                            </div>

                        </div>

                        <div ng-show="contractDetails.publishingContract" >
                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete" > <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>

                                    <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">EXCEL</a>
                                </div>
                            </div>
                            <div className="hover-box pull-left mb">
                                <button className="icon-btn delete"> <i className="icon-files"></i></button>
                                <div className="hover-block">
                                    <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left">PDF</a>
                                </div>
                            </div>
                        </div>
                        <div className="hover-box btn btn-large icon-btn delete pull-left mb">
                            <i className="icon-save"></i>
                        </div>

                        <div className="hover-box icon-btn delete pull-left"><i className="icon-calculator"></i></div>



                    </div>
                    <div className="row-fluid hide" >
                        <div className="hover-box pull-left mb">
                            <button className="icon-btn delete" > <i className="icon-files"></i></button>
                            <div className="hover-block">
                                <a className="hover-box btn btn-large btn-app icon-btn delete btn-xs pull-left" >PDF</a>
                                <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">RPT</a>
                                <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left" >EXCEL</a>
                                <a className="hover-box btn btn-large btn-app icon-btn edit btn-xs pull-left">CSV</a>
                            </div>
                        </div>
                    </div>
                    <div className="alert alert-info mt pull-left hide">Post Adjustment has been executed</div>

                    <div className="row-fluid hide">
                    </div>

                </div>
            </div>
    );

}